import HealthDataPopup from './HealthDataPopup';

export default HealthDataPopup;
